import { CampaignConnectionModel } from '../model';

/**
 * Retrieve the campaign history for the selected org member or an empty array if they have no connections/no history
 * @param campaignConnectionArr
 * @param selectedMemberId
 * @returns
 */
export function parseCampaignHistory(
    campaignConnectionArr: readonly CampaignConnectionModel[],
    selectedMemberId: string
) {
    const campaignConnection = campaignConnectionArr.filter(
        (contactConnect) => contactConnect.orgMemberId === selectedMemberId
    );
    if (campaignConnection.length !== 1) {
        return [];
    }
    return campaignConnection[0].campaignHistory ? campaignConnection[0].campaignHistory : [];
}

/**
 * Opens new insights page in a new tab
 * @param connectionId The connection id to open insights for
 */
export function handleOpenPersonalizedInsightsNew(connectionId: string) {
    window.open(`/insights/connection/${connectionId}`, '_blank');
}
